<template>
    <jet-dialog-modal ref="modal" :show="show_modal" maxWidth="lg" @close="closeModal">
        <template v-slot:title>
            <div class="flex text-gray-700">
                <KeyIcon class="w-6 h-6 text-gray-400 mr-5"></KeyIcon><span>Happyfox Credentials</span>
                <!-- <vue-feather type="link-2" class="h-5 w-5 ml-2 self-center"></vue-feather> -->
            </div>
        </template>
        <template v-slot:content>

            <div class="text-gray-600 mt-5 text-sm font-bold">
                Your Happyfox domain
            </div>
            <div class="text-gray-600 grid grid-cols-6 gap-4">
                
                <div class="col-span-6 flex flex-col justify-center">
                   <jet-input id="domain"
                        type="url"
                        ref="domain"
                        class="mt-1 mr-6 block w-full"
                        v-model="domain"
                        placeholder="https://yourcompany.happyfox.com" />
                </div>
            </div>
            <div class="text-gray-500 mt-0 text-sm">
                It should start with https:// and end with happyfox.com or happyfox.net
            </div>

            <div class="text-gray-600 mt-5 text-sm font-bold">
                Your API Key
            </div>
            <div class="text-gray-600 grid grid-cols-6 gap-4">
                <div class="col-span-6 flex flex-col justify-center">
                   <jet-input id="apikey"
                        type="text"
                        ref="apikey"
                        class="mt-1 mr-6 block w-full"
                        v-model="apikey"
                        placeholder="Paste your API Key here…" />
                </div>
            </div>
            <div class="text-gray-600 mt-5 text-sm font-bold">
                Your Auth Code
            </div>
            <div class="text-gray-600 grid grid-cols-6 gap-4">
                <div class="col-span-6 flex flex-col justify-center">
                   <jet-input id="authcode"
                        type="text"
                        ref="authcode"
                        class="mt-1 mr-6 block w-full"
                        v-model="authcode"
                        placeholder="Paste your Auth Code here…" />
                </div>

            </div>
        </template>
        <template v-slot:footer>
            <div class="flex w-full flex-row justify-between">
                <div class="flex w-full gap-x-10">
                    <button :type="type" class="inline-flex items-center justify-center px-4 py-2 bg-gray-400 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring focus:ring-gray-300 disabled:opacity-25 disabled:cursor-default transition w-full place-content-center" @click="closeModal">
                        Cancel
                    </button>

                    <jet-button
                        class="w-full place-content-center"
                        :disabled="!keyValid || !codeValid || !domainValid || saving"
                        @click="save">
                        <span v-if="saving">Saving</span>
                        <span v-else>Save</span> 
                        <ArrowPathIcon v-show="saving" class="ml-2 w-5 h-5 animate-spin" />
                    </jet-button>
                </div>
            </div>
        </template>
    </jet-dialog-modal>
</template>

<script>

import JetDialogModal from '@/Jetstream/DialogModal'
import JetButton from '@/Jetstream/Button'
import JetInput from '@/Jetstream/Input'
import JetLabel from '@/Jetstream/Label'
import { KeyIcon, ArrowPathIcon } from "@heroicons/vue/20/solid";


export default {

    props: {
        initial_domain: {
            type: String,
            default: ''
        },
        show: {
            type: Boolean,
            default: false
        },
        saving: {
            type: Boolean,
            default: false
        }
    },

    components: {
        JetDialogModal, JetButton, JetInput, JetLabel, KeyIcon, ArrowPathIcon
    },

    data() {
        return {
            show_modal: false,
            apikey: null,
            authcode: null,
            domain: null,
            keyValid: false,
            codeValid: false,
            domainValid: false
        }
    },

    created: function() {
        if (this.initial_domain != "") {
            this.domain = this.initial_domain
        }
    },

    emits: ["callback"],

    methods: {
        closeModalForce: function() {
            this.show_modal = false
        },
        closeModal: function() {
            if (!this.saving) {
                this.show_modal = false
            }
        },
        open: function() {
            this.apikey = null
            this.authcode = null
            this.show_modal = true
            setTimeout(function(){
                if (this.domain == null && this.$refs.domain) {
                    this.$refs.domain.focus()
                } else if (this.$refs.apikey) {
                    this.$refs.apikey.focus()
                }
            }.bind(this), 300)
        },
        // close: function() {
        //     this.$emit('callback', { apikey: null })
        //     this.show_modal = false
        // },
        save: function() {
            if (this.keyValid && this.codeValid && this.domainValid && !this.saving) {
                this.$emit('callback', { apikey: this.apikey, authcode: this.authcode, domain: this.domain })
            }  
            // this.show_modal = false
        },
        checkingForApiKey: function() {
            
        },
        validateNotempty: function(value) {
            var re = /^\s*\S+.*/;
            return re.test(value);
        },
        // validateUrl: function(value) {
        //     return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
        // },
        validateUrl_happyfox: function(value) {
            // force start with https, and end with either happyfox.com or happyfox.net
            const regex = /^https:\/\/([a-zA-Z0-9-]+)\.happyfox\.(com|net)\/?$/;
            return regex.test(value);
        }

    },

    watch: {
        apikey(value){
            this.apiKey = value;
            this.keyValid = value!=null && this.validateNotempty(value) && value.length > 10
        },
        authcode(value){
            this.authcode = value;
            this.codeValid = value!=null && this.validateNotempty(value) && value.length > 10
        },
        domain(value){
            this.domain = value;
            this.domainValid = value!=null && this.validateUrl_happyfox(value)
        }
    },

}

</script>


